import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";

import { useAppDispatch } from "../store";
import { userState } from "../store/data/user";
import { useTeamConfig } from "./useTeamConfig";
import { errorToast } from "../utils/errorToast";
import { globalConfig } from "../config/global_config";
import { useOktaHelper } from "@/features/oAuth/provider/OktaProvider";
import { handleRemoveUpdatedAccountGroup } from "@/shared/modules/PurchaseSeats/Packs/packs.utils";
import { useMlbBallparkStore } from "../store/useMlbBallparkStore";

export function useTicketsdotcom() {
  const oktaCtx = useOktaAuth();
  const { mlbBallparkOktaId } = useMlbBallparkStore();
  const teamConfig = useTeamConfig();
  const { teamSchema } = teamConfig;
  const isMlbBallparkSSOEnabled = teamConfig?.authConfigs?.isMlbBallparkSSOEnabled; // prettier-ignore
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const frontendUrl = globalConfig.frontendUrl;
  const { handlePostOktaAuth, handleGetOktaAuthClient } = useOktaHelper();

  async function handleLoginOkta(state: any) {
    try {
      setIsLoading(true);
      state = window.btoa(JSON.stringify(state));

      if (oktaCtx) {
        window.localStorage.removeItem("okta-token-storage");
        window.localStorage.removeItem("okta-cache-storage");
        window.localStorage.removeItem("okta-original-uri-storage");
        window.localStorage.removeItem("okta-shared-transaction-storage");

        await oktaCtx.oktaAuth.closeSession();
        await oktaCtx.oktaAuth.clearStorage();

        if (isMlbBallparkSSOEnabled && mlbBallparkOktaId) {
          await handlePostOktaAuth(oktaCtx.oktaAuth, state);
        } else {
          const isAuthenticated = await oktaCtx?.oktaAuth?.isAuthenticated();
          if (!isAuthenticated) await oktaCtx.oktaAuth.signInWithRedirect({ state }); // prettier-ignore
          if (isAuthenticated) await handlePostOktaAuth(oktaCtx.oktaAuth, state); // prettier-ignore
        }
      }
    } catch (error: any) {
      console.log(error);
      errorToast(error);
      setIsLoading(false);
    }
  }

  async function handleSignOut(redirectUrl?: string) {
    try {
      setIsLoading(true);
      const url = frontendUrl;
      const redirectUri = `${url}/${teamSchema}`;
      dispatch(userState.actions.remove({ teamSchema }));

      const oktaClient = handleGetOktaAuthClient();

      window.localStorage.removeItem("okta-token-storage");
      window.localStorage.removeItem("okta-cache-storage");
      window.localStorage.removeItem("okta-original-uri-storage");
      window.localStorage.removeItem("okta-shared-transaction-storage");

      handleRemoveUpdatedAccountGroup(teamSchema);
      await oktaClient.signOut();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    handleLoginOkta,
    handleSignOut,
    oktaAuthLoading: isLoading,
    oktaCtx,
  };
}
